// source: apigateway/category/top.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.category.GetTopReply', null, global);
goog.exportSymbol('proto.category.GetTopRequest', null, global);
goog.exportSymbol('proto.category.PopularCategory', null, global);
goog.exportSymbol('proto.category.ProviderDetail', null, global);
goog.exportSymbol('proto.category.RatingData', null, global);
goog.exportSymbol('proto.category.RecommendSearchTag', null, global);
goog.exportSymbol('proto.category.SearchProviderLevel', null, global);
goog.exportSymbol('proto.category.SearchTag', null, global);
goog.exportSymbol('proto.category.Service', null, global);
goog.exportSymbol('proto.category.ServiceProvider', null, global);
goog.exportSymbol('proto.category.ServiceRanking', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.GetTopRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.category.GetTopRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.GetTopRequest.displayName = 'proto.category.GetTopRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.GetTopReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.category.GetTopReply.repeatedFields_, null);
};
goog.inherits(proto.category.GetTopReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.GetTopReply.displayName = 'proto.category.GetTopReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.PopularCategory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.category.PopularCategory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.PopularCategory.displayName = 'proto.category.PopularCategory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.RecommendSearchTag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.category.RecommendSearchTag.repeatedFields_, null);
};
goog.inherits(proto.category.RecommendSearchTag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.RecommendSearchTag.displayName = 'proto.category.RecommendSearchTag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.SearchTag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.category.SearchTag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.SearchTag.displayName = 'proto.category.SearchTag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.ServiceRanking = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.category.ServiceRanking.repeatedFields_, null);
};
goog.inherits(proto.category.ServiceRanking, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.ServiceRanking.displayName = 'proto.category.ServiceRanking';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.Service = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.category.Service, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.Service.displayName = 'proto.category.Service';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.RatingData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.category.RatingData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.RatingData.displayName = 'proto.category.RatingData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.ServiceProvider = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.category.ServiceProvider, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.ServiceProvider.displayName = 'proto.category.ServiceProvider';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.ProviderDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.category.ProviderDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.ProviderDetail.displayName = 'proto.category.ProviderDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.SearchProviderLevel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.category.SearchProviderLevel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.SearchProviderLevel.displayName = 'proto.category.SearchProviderLevel';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.GetTopRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.category.GetTopRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.GetTopRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.GetTopRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    businessFlag: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    masterCategoryId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.GetTopRequest}
 */
proto.category.GetTopRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.GetTopRequest;
  return proto.category.GetTopRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.GetTopRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.GetTopRequest}
 */
proto.category.GetTopRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBusinessFlag(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMasterCategoryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.GetTopRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.GetTopRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.GetTopRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.GetTopRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBusinessFlag();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMasterCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional bool business_flag = 2;
 * @return {boolean}
 */
proto.category.GetTopRequest.prototype.getBusinessFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.category.GetTopRequest} returns this
 */
proto.category.GetTopRequest.prototype.setBusinessFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional int32 master_category_id = 3;
 * @return {number}
 */
proto.category.GetTopRequest.prototype.getMasterCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.GetTopRequest} returns this
 */
proto.category.GetTopRequest.prototype.setMasterCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.category.GetTopReply.repeatedFields_ = [1,2,4,5,6,7,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.GetTopReply.prototype.toObject = function(opt_includeInstance) {
  return proto.category.GetTopReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.GetTopReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.GetTopReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    popularCategoriesList: jspb.Message.toObjectList(msg.getPopularCategoriesList(),
    proto.category.PopularCategory.toObject, includeInstance),
    recommendSearchTagsList: jspb.Message.toObjectList(msg.getRecommendSearchTagsList(),
    proto.category.RecommendSearchTag.toObject, includeInstance),
    recommendServicesList: jspb.Message.toObjectList(msg.getRecommendServicesList(),
    proto.category.Service.toObject, includeInstance),
    manyFavoritedServicesList: jspb.Message.toObjectList(msg.getManyFavoritedServicesList(),
    proto.category.Service.toObject, includeInstance),
    newlyArrivedServicesList: jspb.Message.toObjectList(msg.getNewlyArrivedServicesList(),
    proto.category.Service.toObject, includeInstance),
    providerRankingList: jspb.Message.toObjectList(msg.getProviderRankingList(),
    proto.category.ProviderDetail.toObject, includeInstance),
    providerPhoneWaitServicesList: jspb.Message.toObjectList(msg.getProviderPhoneWaitServicesList(),
    proto.category.Service.toObject, includeInstance),
    serviceRankingsList: jspb.Message.toObjectList(msg.getServiceRankingsList(),
    proto.category.ServiceRanking.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.GetTopReply}
 */
proto.category.GetTopReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.GetTopReply;
  return proto.category.GetTopReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.GetTopReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.GetTopReply}
 */
proto.category.GetTopReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.category.PopularCategory;
      reader.readMessage(value,proto.category.PopularCategory.deserializeBinaryFromReader);
      msg.addPopularCategories(value);
      break;
    case 2:
      var value = new proto.category.RecommendSearchTag;
      reader.readMessage(value,proto.category.RecommendSearchTag.deserializeBinaryFromReader);
      msg.addRecommendSearchTags(value);
      break;
    case 4:
      var value = new proto.category.Service;
      reader.readMessage(value,proto.category.Service.deserializeBinaryFromReader);
      msg.addRecommendServices(value);
      break;
    case 5:
      var value = new proto.category.Service;
      reader.readMessage(value,proto.category.Service.deserializeBinaryFromReader);
      msg.addManyFavoritedServices(value);
      break;
    case 6:
      var value = new proto.category.Service;
      reader.readMessage(value,proto.category.Service.deserializeBinaryFromReader);
      msg.addNewlyArrivedServices(value);
      break;
    case 7:
      var value = new proto.category.ProviderDetail;
      reader.readMessage(value,proto.category.ProviderDetail.deserializeBinaryFromReader);
      msg.addProviderRanking(value);
      break;
    case 8:
      var value = new proto.category.Service;
      reader.readMessage(value,proto.category.Service.deserializeBinaryFromReader);
      msg.addProviderPhoneWaitServices(value);
      break;
    case 9:
      var value = new proto.category.ServiceRanking;
      reader.readMessage(value,proto.category.ServiceRanking.deserializeBinaryFromReader);
      msg.addServiceRankings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.GetTopReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.GetTopReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.GetTopReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.GetTopReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPopularCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.category.PopularCategory.serializeBinaryToWriter
    );
  }
  f = message.getRecommendSearchTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.category.RecommendSearchTag.serializeBinaryToWriter
    );
  }
  f = message.getRecommendServicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.category.Service.serializeBinaryToWriter
    );
  }
  f = message.getManyFavoritedServicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.category.Service.serializeBinaryToWriter
    );
  }
  f = message.getNewlyArrivedServicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.category.Service.serializeBinaryToWriter
    );
  }
  f = message.getProviderRankingList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.category.ProviderDetail.serializeBinaryToWriter
    );
  }
  f = message.getProviderPhoneWaitServicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.category.Service.serializeBinaryToWriter
    );
  }
  f = message.getServiceRankingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.category.ServiceRanking.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PopularCategory popular_categories = 1;
 * @return {!Array<!proto.category.PopularCategory>}
 */
proto.category.GetTopReply.prototype.getPopularCategoriesList = function() {
  return /** @type{!Array<!proto.category.PopularCategory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.category.PopularCategory, 1));
};


/**
 * @param {!Array<!proto.category.PopularCategory>} value
 * @return {!proto.category.GetTopReply} returns this
*/
proto.category.GetTopReply.prototype.setPopularCategoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.category.PopularCategory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.category.PopularCategory}
 */
proto.category.GetTopReply.prototype.addPopularCategories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.category.PopularCategory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetTopReply} returns this
 */
proto.category.GetTopReply.prototype.clearPopularCategoriesList = function() {
  return this.setPopularCategoriesList([]);
};


/**
 * repeated RecommendSearchTag recommend_search_tags = 2;
 * @return {!Array<!proto.category.RecommendSearchTag>}
 */
proto.category.GetTopReply.prototype.getRecommendSearchTagsList = function() {
  return /** @type{!Array<!proto.category.RecommendSearchTag>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.category.RecommendSearchTag, 2));
};


/**
 * @param {!Array<!proto.category.RecommendSearchTag>} value
 * @return {!proto.category.GetTopReply} returns this
*/
proto.category.GetTopReply.prototype.setRecommendSearchTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.category.RecommendSearchTag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.category.RecommendSearchTag}
 */
proto.category.GetTopReply.prototype.addRecommendSearchTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.category.RecommendSearchTag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetTopReply} returns this
 */
proto.category.GetTopReply.prototype.clearRecommendSearchTagsList = function() {
  return this.setRecommendSearchTagsList([]);
};


/**
 * repeated Service recommend_services = 4;
 * @return {!Array<!proto.category.Service>}
 */
proto.category.GetTopReply.prototype.getRecommendServicesList = function() {
  return /** @type{!Array<!proto.category.Service>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.category.Service, 4));
};


/**
 * @param {!Array<!proto.category.Service>} value
 * @return {!proto.category.GetTopReply} returns this
*/
proto.category.GetTopReply.prototype.setRecommendServicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.category.Service=} opt_value
 * @param {number=} opt_index
 * @return {!proto.category.Service}
 */
proto.category.GetTopReply.prototype.addRecommendServices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.category.Service, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetTopReply} returns this
 */
proto.category.GetTopReply.prototype.clearRecommendServicesList = function() {
  return this.setRecommendServicesList([]);
};


/**
 * repeated Service many_favorited_services = 5;
 * @return {!Array<!proto.category.Service>}
 */
proto.category.GetTopReply.prototype.getManyFavoritedServicesList = function() {
  return /** @type{!Array<!proto.category.Service>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.category.Service, 5));
};


/**
 * @param {!Array<!proto.category.Service>} value
 * @return {!proto.category.GetTopReply} returns this
*/
proto.category.GetTopReply.prototype.setManyFavoritedServicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.category.Service=} opt_value
 * @param {number=} opt_index
 * @return {!proto.category.Service}
 */
proto.category.GetTopReply.prototype.addManyFavoritedServices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.category.Service, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetTopReply} returns this
 */
proto.category.GetTopReply.prototype.clearManyFavoritedServicesList = function() {
  return this.setManyFavoritedServicesList([]);
};


/**
 * repeated Service newly_arrived_services = 6;
 * @return {!Array<!proto.category.Service>}
 */
proto.category.GetTopReply.prototype.getNewlyArrivedServicesList = function() {
  return /** @type{!Array<!proto.category.Service>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.category.Service, 6));
};


/**
 * @param {!Array<!proto.category.Service>} value
 * @return {!proto.category.GetTopReply} returns this
*/
proto.category.GetTopReply.prototype.setNewlyArrivedServicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.category.Service=} opt_value
 * @param {number=} opt_index
 * @return {!proto.category.Service}
 */
proto.category.GetTopReply.prototype.addNewlyArrivedServices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.category.Service, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetTopReply} returns this
 */
proto.category.GetTopReply.prototype.clearNewlyArrivedServicesList = function() {
  return this.setNewlyArrivedServicesList([]);
};


/**
 * repeated ProviderDetail provider_ranking = 7;
 * @return {!Array<!proto.category.ProviderDetail>}
 */
proto.category.GetTopReply.prototype.getProviderRankingList = function() {
  return /** @type{!Array<!proto.category.ProviderDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.category.ProviderDetail, 7));
};


/**
 * @param {!Array<!proto.category.ProviderDetail>} value
 * @return {!proto.category.GetTopReply} returns this
*/
proto.category.GetTopReply.prototype.setProviderRankingList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.category.ProviderDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.category.ProviderDetail}
 */
proto.category.GetTopReply.prototype.addProviderRanking = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.category.ProviderDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetTopReply} returns this
 */
proto.category.GetTopReply.prototype.clearProviderRankingList = function() {
  return this.setProviderRankingList([]);
};


/**
 * repeated Service provider_phone_wait_services = 8;
 * @return {!Array<!proto.category.Service>}
 */
proto.category.GetTopReply.prototype.getProviderPhoneWaitServicesList = function() {
  return /** @type{!Array<!proto.category.Service>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.category.Service, 8));
};


/**
 * @param {!Array<!proto.category.Service>} value
 * @return {!proto.category.GetTopReply} returns this
*/
proto.category.GetTopReply.prototype.setProviderPhoneWaitServicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.category.Service=} opt_value
 * @param {number=} opt_index
 * @return {!proto.category.Service}
 */
proto.category.GetTopReply.prototype.addProviderPhoneWaitServices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.category.Service, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetTopReply} returns this
 */
proto.category.GetTopReply.prototype.clearProviderPhoneWaitServicesList = function() {
  return this.setProviderPhoneWaitServicesList([]);
};


/**
 * repeated ServiceRanking service_rankings = 9;
 * @return {!Array<!proto.category.ServiceRanking>}
 */
proto.category.GetTopReply.prototype.getServiceRankingsList = function() {
  return /** @type{!Array<!proto.category.ServiceRanking>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.category.ServiceRanking, 9));
};


/**
 * @param {!Array<!proto.category.ServiceRanking>} value
 * @return {!proto.category.GetTopReply} returns this
*/
proto.category.GetTopReply.prototype.setServiceRankingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.category.ServiceRanking=} opt_value
 * @param {number=} opt_index
 * @return {!proto.category.ServiceRanking}
 */
proto.category.GetTopReply.prototype.addServiceRankings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.category.ServiceRanking, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetTopReply} returns this
 */
proto.category.GetTopReply.prototype.clearServiceRankingsList = function() {
  return this.setServiceRankingsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.PopularCategory.prototype.toObject = function(opt_includeInstance) {
  return proto.category.PopularCategory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.PopularCategory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.PopularCategory.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.PopularCategory}
 */
proto.category.PopularCategory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.PopularCategory;
  return proto.category.PopularCategory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.PopularCategory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.PopularCategory}
 */
proto.category.PopularCategory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.PopularCategory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.PopularCategory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.PopularCategory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.PopularCategory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.category.PopularCategory.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.PopularCategory} returns this
 */
proto.category.PopularCategory.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.category.PopularCategory.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.PopularCategory} returns this
 */
proto.category.PopularCategory.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.category.RecommendSearchTag.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.RecommendSearchTag.prototype.toObject = function(opt_includeInstance) {
  return proto.category.RecommendSearchTag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.RecommendSearchTag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.RecommendSearchTag.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    searchTagsList: jspb.Message.toObjectList(msg.getSearchTagsList(),
    proto.category.SearchTag.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.RecommendSearchTag}
 */
proto.category.RecommendSearchTag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.RecommendSearchTag;
  return proto.category.RecommendSearchTag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.RecommendSearchTag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.RecommendSearchTag}
 */
proto.category.RecommendSearchTag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupName(value);
      break;
    case 2:
      var value = new proto.category.SearchTag;
      reader.readMessage(value,proto.category.SearchTag.deserializeBinaryFromReader);
      msg.addSearchTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.RecommendSearchTag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.RecommendSearchTag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.RecommendSearchTag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.RecommendSearchTag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSearchTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.category.SearchTag.serializeBinaryToWriter
    );
  }
};


/**
 * optional string group_name = 1;
 * @return {string}
 */
proto.category.RecommendSearchTag.prototype.getGroupName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.RecommendSearchTag} returns this
 */
proto.category.RecommendSearchTag.prototype.setGroupName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated SearchTag search_tags = 2;
 * @return {!Array<!proto.category.SearchTag>}
 */
proto.category.RecommendSearchTag.prototype.getSearchTagsList = function() {
  return /** @type{!Array<!proto.category.SearchTag>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.category.SearchTag, 2));
};


/**
 * @param {!Array<!proto.category.SearchTag>} value
 * @return {!proto.category.RecommendSearchTag} returns this
*/
proto.category.RecommendSearchTag.prototype.setSearchTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.category.SearchTag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.category.SearchTag}
 */
proto.category.RecommendSearchTag.prototype.addSearchTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.category.SearchTag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.RecommendSearchTag} returns this
 */
proto.category.RecommendSearchTag.prototype.clearSearchTagsList = function() {
  return this.setSearchTagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.SearchTag.prototype.toObject = function(opt_includeInstance) {
  return proto.category.SearchTag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.SearchTag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.SearchTag.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    url: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.SearchTag}
 */
proto.category.SearchTag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.SearchTag;
  return proto.category.SearchTag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.SearchTag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.SearchTag}
 */
proto.category.SearchTag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.SearchTag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.SearchTag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.SearchTag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.SearchTag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.category.SearchTag.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.SearchTag} returns this
 */
proto.category.SearchTag.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.category.SearchTag.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.SearchTag} returns this
 */
proto.category.SearchTag.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.category.ServiceRanking.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.ServiceRanking.prototype.toObject = function(opt_includeInstance) {
  return proto.category.ServiceRanking.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.ServiceRanking} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.ServiceRanking.toObject = function(includeInstance, msg) {
  var f, obj = {
    tallyingPeriodFrom: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tallyingPeriodTo: jspb.Message.getFieldWithDefault(msg, 2, 0),
    servicesList: jspb.Message.toObjectList(msg.getServicesList(),
    proto.category.Service.toObject, includeInstance),
    title: jspb.Message.getFieldWithDefault(msg, 4, ""),
    url: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.ServiceRanking}
 */
proto.category.ServiceRanking.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.ServiceRanking;
  return proto.category.ServiceRanking.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.ServiceRanking} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.ServiceRanking}
 */
proto.category.ServiceRanking.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTallyingPeriodFrom(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTallyingPeriodTo(value);
      break;
    case 3:
      var value = new proto.category.Service;
      reader.readMessage(value,proto.category.Service.deserializeBinaryFromReader);
      msg.addServices(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.ServiceRanking.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.ServiceRanking.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.ServiceRanking} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.ServiceRanking.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTallyingPeriodFrom();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTallyingPeriodTo();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getServicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.category.Service.serializeBinaryToWriter
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int64 tallying_period_from = 1;
 * @return {number}
 */
proto.category.ServiceRanking.prototype.getTallyingPeriodFrom = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.ServiceRanking} returns this
 */
proto.category.ServiceRanking.prototype.setTallyingPeriodFrom = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 tallying_period_to = 2;
 * @return {number}
 */
proto.category.ServiceRanking.prototype.getTallyingPeriodTo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.ServiceRanking} returns this
 */
proto.category.ServiceRanking.prototype.setTallyingPeriodTo = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated Service services = 3;
 * @return {!Array<!proto.category.Service>}
 */
proto.category.ServiceRanking.prototype.getServicesList = function() {
  return /** @type{!Array<!proto.category.Service>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.category.Service, 3));
};


/**
 * @param {!Array<!proto.category.Service>} value
 * @return {!proto.category.ServiceRanking} returns this
*/
proto.category.ServiceRanking.prototype.setServicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.category.Service=} opt_value
 * @param {number=} opt_index
 * @return {!proto.category.Service}
 */
proto.category.ServiceRanking.prototype.addServices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.category.Service, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.ServiceRanking} returns this
 */
proto.category.ServiceRanking.prototype.clearServicesList = function() {
  return this.setServicesList([]);
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.category.ServiceRanking.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.ServiceRanking} returns this
 */
proto.category.ServiceRanking.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string url = 5;
 * @return {string}
 */
proto.category.ServiceRanking.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.ServiceRanking} returns this
 */
proto.category.ServiceRanking.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.Service.prototype.toObject = function(opt_includeInstance) {
  return proto.category.Service.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.Service} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.Service.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    priceWot: jspb.Message.getFieldWithDefault(msg, 3, 0),
    serviceClass: jspb.Message.getFieldWithDefault(msg, 4, 0),
    videoType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    proServiceFlag: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    moviePriorityFlag: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    videoServiceFlag: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    unitTime: jspb.Message.getFieldWithDefault(msg, 9, 0),
    serviceImage: jspb.Message.getFieldWithDefault(msg, 10, ""),
    serviceMovie: jspb.Message.getFieldWithDefault(msg, 11, ""),
    provider: (f = msg.getProvider()) && proto.category.ServiceProvider.toObject(includeInstance, f),
    ratings: (f = msg.getRatings()) && proto.category.RatingData.toObject(includeInstance, f),
    performanceCount: jspb.Message.getFieldWithDefault(msg, 14, 0),
    certificationDivinationServiceFlag: jspb.Message.getBooleanFieldWithDefault(msg, 15, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.Service}
 */
proto.category.Service.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.Service;
  return proto.category.Service.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.Service} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.Service}
 */
proto.category.Service.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPriceWot(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setServiceClass(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVideoType(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProServiceFlag(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMoviePriorityFlag(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVideoServiceFlag(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUnitTime(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceImage(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceMovie(value);
      break;
    case 12:
      var value = new proto.category.ServiceProvider;
      reader.readMessage(value,proto.category.ServiceProvider.deserializeBinaryFromReader);
      msg.setProvider(value);
      break;
    case 13:
      var value = new proto.category.RatingData;
      reader.readMessage(value,proto.category.RatingData.deserializeBinaryFromReader);
      msg.setRatings(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerformanceCount(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCertificationDivinationServiceFlag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.Service.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.Service.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.Service} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.Service.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPriceWot();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getServiceClass();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getVideoType();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getProServiceFlag();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getMoviePriorityFlag();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getVideoServiceFlag();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getUnitTime();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getServiceImage();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getServiceMovie();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getProvider();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.category.ServiceProvider.serializeBinaryToWriter
    );
  }
  f = message.getRatings();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.category.RatingData.serializeBinaryToWriter
    );
  }
  f = message.getPerformanceCount();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getCertificationDivinationServiceFlag();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.category.Service.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.Service} returns this
 */
proto.category.Service.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.category.Service.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.Service} returns this
 */
proto.category.Service.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 price_wot = 3;
 * @return {number}
 */
proto.category.Service.prototype.getPriceWot = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.Service} returns this
 */
proto.category.Service.prototype.setPriceWot = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 service_class = 4;
 * @return {number}
 */
proto.category.Service.prototype.getServiceClass = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.Service} returns this
 */
proto.category.Service.prototype.setServiceClass = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 video_type = 5;
 * @return {number}
 */
proto.category.Service.prototype.getVideoType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.Service} returns this
 */
proto.category.Service.prototype.setVideoType = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool pro_service_flag = 6;
 * @return {boolean}
 */
proto.category.Service.prototype.getProServiceFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.category.Service} returns this
 */
proto.category.Service.prototype.setProServiceFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool movie_priority_flag = 7;
 * @return {boolean}
 */
proto.category.Service.prototype.getMoviePriorityFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.category.Service} returns this
 */
proto.category.Service.prototype.setMoviePriorityFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool video_service_flag = 8;
 * @return {boolean}
 */
proto.category.Service.prototype.getVideoServiceFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.category.Service} returns this
 */
proto.category.Service.prototype.setVideoServiceFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int32 unit_time = 9;
 * @return {number}
 */
proto.category.Service.prototype.getUnitTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.Service} returns this
 */
proto.category.Service.prototype.setUnitTime = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string service_image = 10;
 * @return {string}
 */
proto.category.Service.prototype.getServiceImage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.Service} returns this
 */
proto.category.Service.prototype.setServiceImage = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string service_movie = 11;
 * @return {string}
 */
proto.category.Service.prototype.getServiceMovie = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.Service} returns this
 */
proto.category.Service.prototype.setServiceMovie = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional ServiceProvider provider = 12;
 * @return {?proto.category.ServiceProvider}
 */
proto.category.Service.prototype.getProvider = function() {
  return /** @type{?proto.category.ServiceProvider} */ (
    jspb.Message.getWrapperField(this, proto.category.ServiceProvider, 12));
};


/**
 * @param {?proto.category.ServiceProvider|undefined} value
 * @return {!proto.category.Service} returns this
*/
proto.category.Service.prototype.setProvider = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.category.Service} returns this
 */
proto.category.Service.prototype.clearProvider = function() {
  return this.setProvider(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.category.Service.prototype.hasProvider = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional RatingData ratings = 13;
 * @return {?proto.category.RatingData}
 */
proto.category.Service.prototype.getRatings = function() {
  return /** @type{?proto.category.RatingData} */ (
    jspb.Message.getWrapperField(this, proto.category.RatingData, 13));
};


/**
 * @param {?proto.category.RatingData|undefined} value
 * @return {!proto.category.Service} returns this
*/
proto.category.Service.prototype.setRatings = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.category.Service} returns this
 */
proto.category.Service.prototype.clearRatings = function() {
  return this.setRatings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.category.Service.prototype.hasRatings = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional int32 performance_count = 14;
 * @return {number}
 */
proto.category.Service.prototype.getPerformanceCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.Service} returns this
 */
proto.category.Service.prototype.setPerformanceCount = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional bool certification_divination_service_flag = 15;
 * @return {boolean}
 */
proto.category.Service.prototype.getCertificationDivinationServiceFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.category.Service} returns this
 */
proto.category.Service.prototype.setCertificationDivinationServiceFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.RatingData.prototype.toObject = function(opt_includeInstance) {
  return proto.category.RatingData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.RatingData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.RatingData.toObject = function(includeInstance, msg) {
  var f, obj = {
    indicator: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    ratingCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.RatingData}
 */
proto.category.RatingData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.RatingData;
  return proto.category.RatingData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.RatingData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.RatingData}
 */
proto.category.RatingData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setIndicator(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRatingCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.RatingData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.RatingData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.RatingData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.RatingData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIndicator();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getRatingCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional double indicator = 1;
 * @return {number}
 */
proto.category.RatingData.prototype.getIndicator = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.category.RatingData} returns this
 */
proto.category.RatingData.prototype.setIndicator = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional int32 rating_count = 2;
 * @return {number}
 */
proto.category.RatingData.prototype.getRatingCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.RatingData} returns this
 */
proto.category.RatingData.prototype.setRatingCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.ServiceProvider.prototype.toObject = function(opt_includeInstance) {
  return proto.category.ServiceProvider.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.ServiceProvider} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.ServiceProvider.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    profileIconPath: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.ServiceProvider}
 */
proto.category.ServiceProvider.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.ServiceProvider;
  return proto.category.ServiceProvider.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.ServiceProvider} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.ServiceProvider}
 */
proto.category.ServiceProvider.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileIconPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.ServiceProvider.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.ServiceProvider.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.ServiceProvider} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.ServiceProvider.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProfileIconPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.category.ServiceProvider.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.ServiceProvider} returns this
 */
proto.category.ServiceProvider.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.category.ServiceProvider.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.ServiceProvider} returns this
 */
proto.category.ServiceProvider.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string profile_icon_path = 3;
 * @return {string}
 */
proto.category.ServiceProvider.prototype.getProfileIconPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.ServiceProvider} returns this
 */
proto.category.ServiceProvider.prototype.setProfileIconPath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.ProviderDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.category.ProviderDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.ProviderDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.ProviderDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    resizableProfileIcon: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    occupation: jspb.Message.getFieldWithDefault(msg, 4, ""),
    averageRating: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    paidOrderCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    providerLevel: (f = msg.getProviderLevel()) && proto.category.SearchProviderLevel.toObject(includeInstance, f),
    isPro: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    isCertificationDivination: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.ProviderDetail}
 */
proto.category.ProviderDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.ProviderDetail;
  return proto.category.ProviderDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.ProviderDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.ProviderDetail}
 */
proto.category.ProviderDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setResizableProfileIcon(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOccupation(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAverageRating(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaidOrderCount(value);
      break;
    case 7:
      var value = new proto.category.SearchProviderLevel;
      reader.readMessage(value,proto.category.SearchProviderLevel.deserializeBinaryFromReader);
      msg.setProviderLevel(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPro(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCertificationDivination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.ProviderDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.ProviderDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.ProviderDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.ProviderDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getResizableProfileIcon();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOccupation();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAverageRating();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getPaidOrderCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getProviderLevel();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.category.SearchProviderLevel.serializeBinaryToWriter
    );
  }
  f = message.getIsPro();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getIsCertificationDivination();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.category.ProviderDetail.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.ProviderDetail} returns this
 */
proto.category.ProviderDetail.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string resizable_profile_icon = 2;
 * @return {string}
 */
proto.category.ProviderDetail.prototype.getResizableProfileIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.ProviderDetail} returns this
 */
proto.category.ProviderDetail.prototype.setResizableProfileIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_name = 3;
 * @return {string}
 */
proto.category.ProviderDetail.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.ProviderDetail} returns this
 */
proto.category.ProviderDetail.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string occupation = 4;
 * @return {string}
 */
proto.category.ProviderDetail.prototype.getOccupation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.ProviderDetail} returns this
 */
proto.category.ProviderDetail.prototype.setOccupation = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional float average_rating = 5;
 * @return {number}
 */
proto.category.ProviderDetail.prototype.getAverageRating = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.category.ProviderDetail} returns this
 */
proto.category.ProviderDetail.prototype.setAverageRating = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int32 paid_order_count = 6;
 * @return {number}
 */
proto.category.ProviderDetail.prototype.getPaidOrderCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.ProviderDetail} returns this
 */
proto.category.ProviderDetail.prototype.setPaidOrderCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional SearchProviderLevel provider_level = 7;
 * @return {?proto.category.SearchProviderLevel}
 */
proto.category.ProviderDetail.prototype.getProviderLevel = function() {
  return /** @type{?proto.category.SearchProviderLevel} */ (
    jspb.Message.getWrapperField(this, proto.category.SearchProviderLevel, 7));
};


/**
 * @param {?proto.category.SearchProviderLevel|undefined} value
 * @return {!proto.category.ProviderDetail} returns this
*/
proto.category.ProviderDetail.prototype.setProviderLevel = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.category.ProviderDetail} returns this
 */
proto.category.ProviderDetail.prototype.clearProviderLevel = function() {
  return this.setProviderLevel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.category.ProviderDetail.prototype.hasProviderLevel = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool is_pro = 8;
 * @return {boolean}
 */
proto.category.ProviderDetail.prototype.getIsPro = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.category.ProviderDetail} returns this
 */
proto.category.ProviderDetail.prototype.setIsPro = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool is_certification_divination = 9;
 * @return {boolean}
 */
proto.category.ProviderDetail.prototype.getIsCertificationDivination = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.category.ProviderDetail} returns this
 */
proto.category.ProviderDetail.prototype.setIsCertificationDivination = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.SearchProviderLevel.prototype.toObject = function(opt_includeInstance) {
  return proto.category.SearchProviderLevel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.SearchProviderLevel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.SearchProviderLevel.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0),
    textJp: jspb.Message.getFieldWithDefault(msg, 2, ""),
    textEn: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.SearchProviderLevel}
 */
proto.category.SearchProviderLevel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.SearchProviderLevel;
  return proto.category.SearchProviderLevel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.SearchProviderLevel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.SearchProviderLevel}
 */
proto.category.SearchProviderLevel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextJp(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextEn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.SearchProviderLevel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.SearchProviderLevel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.SearchProviderLevel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.SearchProviderLevel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTextJp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTextEn();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.category.SearchProviderLevel.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.SearchProviderLevel} returns this
 */
proto.category.SearchProviderLevel.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string text_jp = 2;
 * @return {string}
 */
proto.category.SearchProviderLevel.prototype.getTextJp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.SearchProviderLevel} returns this
 */
proto.category.SearchProviderLevel.prototype.setTextJp = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string text_en = 3;
 * @return {string}
 */
proto.category.SearchProviderLevel.prototype.getTextEn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.SearchProviderLevel} returns this
 */
proto.category.SearchProviderLevel.prototype.setTextEn = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


goog.object.extend(exports, proto.category);
